import request from '@/utils/request';

// AI 接口超时时间单独设为 120 秒（大模型响应较慢）
const AI_TIMEOUT = 120000;

/** 步骤3：推荐模板 */
export function generateTemplate(data) {
    return request({ url: '/front/ai/template', method: 'post', data, timeout: AI_TIMEOUT });
}

/** 步骤5：生成故事背景 */
export function generateBackground(data) {
    return request({ url: '/front/ai/background', method: 'post', data, timeout: AI_TIMEOUT });
}

/** 步骤6：生成角色列表 */
export function generateRoles(data) {
    return request({ url: '/front/ai/roles', method: 'post', data, timeout: AI_TIMEOUT });
}

/** 步骤7：生成故事情节 */
export function generatePlot(data) {
    return request({ url: '/front/ai/plot', method: 'post', data, timeout: AI_TIMEOUT });
}

/** 步骤8辅助：生成标题建议 */
export function generateTitles(data) {
    return request({ url: '/front/ai/titles', method: 'post', data, timeout: AI_TIMEOUT });
}

// ---- 长篇小说 AI 生成 ----

/** 生成世界观设定 */
export function generateWorldSetting(data) {
    return request({ url: '/front/ai/novel/world', method: 'post', data, timeout: AI_TIMEOUT });
}

/** 生成核心冲突 */
export function generateConflict(data) {
    return request({ url: '/front/ai/novel/conflict', method: 'post', data, timeout: AI_TIMEOUT });
}

/** 生成长篇角色阵容 */
export function generateLongNovelRoles(data) {
    return request({ url: '/front/ai/novel/roles', method: 'post', data, timeout: AI_TIMEOUT });
}

/** 生成三幕大纲 */
export function generateThreeActOutline(data) {
    return request({ url: '/front/ai/novel/outline', method: 'post', data, timeout: AI_TIMEOUT });
}

/** 生成分卷细纲 */
export function generateVolumeOutline(data) {
    return request({ url: '/front/ai/novel/volumes', method: 'post', data, timeout: AI_TIMEOUT });
}

/** 按三种命名策略生成长篇标题 */
export function generateLongNovelTitles(data) {
    return request({ url: '/front/ai/novel/titles', method: 'post', data, timeout: AI_TIMEOUT });
}

/** 根据章节摘要生成章节正文 */
export function generateChapterContent(data) {
    return request({ url: '/front/ai/novel/chapter-content', method: 'post', data, timeout: AI_TIMEOUT });
}
